import BaseComponent from "../core/base-component.js";
import { createStyleString } from '@capsizecss/core';
import fontMetricsList from "../assets/font-metrics-list.js";

const DEFAULT_ELEMENT_SELECTOR: string = '.capsize';

class Capsize extends BaseComponent {
    public override process() {
        const elementStyle = window.getComputedStyle(this.element);
        const fontFamily = elementStyle.getPropertyValue('font-family');
        let currentFont = fontFamily.split(',')[0].trim();
        currentFont = currentFont.replace(/\"/ig, '');
        const fontSize = elementStyle.getPropertyValue('font-size');
        const lineHeight = elementStyle.getPropertyValue('line-height');

        let fontSizePixel = this.convertToPixel(fontSize);
        let lineHeightPixel = this.convertToPixel(lineHeight);

        const fontMetrics = fontMetricsList.find((item) => item.familyName == currentFont);
        if(fontMetrics) {
            const options = {
                fontSize: fontSizePixel,
                leading: lineHeightPixel,
                fontMetrics: fontMetrics
            };

            const elementShadowRoot = this.element.attachShadow({ mode: "open" });

            const style = createStyleString('capsized', options);
            const styleEl = document.createElement('style');
            styleEl.textContent = style;
            elementShadowRoot.appendChild(styleEl);

            const spanEl = document.createElement('span');
            spanEl.classList.add('capsized');
            spanEl.innerHTML = this.element.innerHTML;
            elementShadowRoot.appendChild(spanEl);

            this.element.classList.add('capsized');
        }

    }

    private convertToPixel(value: string): number {
        const matches = value.match(/(\d+)(.*)/);
        let converted: number = 0;
        if(matches) {
            converted = parseFloat(matches[1]);
            switch(matches[2] ?? '') {
                case 'rem':
                    converted * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
                    break;
                case 'em':
                    converted * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
                    break;
            }
        }
        return converted;
    }

}

// Observe
Capsize.initializeDom(DEFAULT_ELEMENT_SELECTOR, false, false, true);

export default Capsize;
